import { SHIRT_SIZES } from "@/components/RegistrationDetails";

export const registrationErrors = (value, categories, { savedChild, requireParentName = false } = {}) => {
  const errors = {};
  if (savedChild) {
    if (!savedChild.full_name?.trim()) errors.first_name = "Name is required. Edit the saved child's profile to add their name.";
  } else {
    if (!value.first_name?.trim()) errors.first_name = "First Name is required.";
    if (!value.last_name?.trim()) errors.last_name = "Last Name is required.";
  }
  if (!value.current_school?.trim()) errors.current_school = "School is required.";
  if (!SHIRT_SIZES.some((size) => size.value === value.shirt_size)) errors.shirt_size = value.shirt_size ? "Choose an available Shirt Size." : "Shirt Size is required.";
  if (!categories.includes(value.parent_selected_category)) errors.parent_selected_category = "Time Estimate is required. Choose a time range.";
  if (!value.contact_email?.trim()) errors.contact_email = "Parent Email is required.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.contact_email.trim())) errors.contact_email = "Enter a valid Parent Email.";
  if (requireParentName && !value.parent_name?.trim()) errors.parent_name = "Parent / guardian name is required.";
  if (!Number.isInteger(value.grade) || value.grade < 3 || value.grade > 12) errors.grade = "Select the current grade (3–12).";
  if (!Number.isInteger(value.previous_competitions) || value.previous_competitions < 0 || value.previous_competitions > 8) errors.previous_competitions = "Select the number of previous Naptown Cubers competitions (0–8).";
  return errors;
};

export const profileFieldsChanged = (child, value) => child ? ["current_school", "shirt_size"].filter((field) => (value[field] || "").trim() !== (child[field] || "").trim()) : [];

export const RegistrationValidation = ({ errors, prefix }) => {
  if (!Object.keys(errors).length) return null;
  return <div role="alert" tabIndex={-1} className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-800" data-testid={`${prefix}-validation-summary`}>
    <p className="font-semibold">Please complete the following before registering:</p>
    <ul className="mt-2 list-disc pl-5 space-y-1">{Object.entries(errors).map(([field, message]) => <li key={field} id={`${prefix}-validation-${field}`} data-testid={`${prefix}-validation-${field}`}>{message}</li>)}</ul>
  </div>;
};
